/**
 * 模块名称: 待办事项
 * @author xuzhongyuan@372163.com
 */

import React, { useState, useEffect } from 'react'
import BtnGroup from '@/components/BtnGroup'
import { Table, Alert, Form, Input, Select, DatePicker, Button, Drawer, message, Modal } from 'antd'
import api from '@/api'
import { Link } from 'react-router-dom'
import { parseSearch, cryptoParamsIntoUrl } from '@/utils'
import moment from 'moment'
import { scheduleObj } from '@/utils/constant'
import './style.scss'

const Column = Table.Column
const FormItem = Form.Item
const Option = Select.Option
const { RangePicker } = DatePicker

let pageSize = 10
let currentPage = 1
let timeSort = ''
let filter = {
  type: '',
  title: '',
  status: '',
  startTime: '',
  endTime: ''
}

const Schedule = (props) => {
  const { match, location, history } = props
  const { getFieldDecorator, getFieldsValue, resetFields } = props.form
  const [loading, setLoading] = useState(false)
  const [list, setList] = useState([])
  const [count, setCount] = useState(0)
  const [typeList, setTyeList] = useState([])
  const [showConfig, setShowConfig] = useState(false)
  const [configList, setConfigList] = useState([])
  const [selectedKeys, setSelectedkeys] = useState([])
  const search = parseSearch(location.search)

  useEffect(() => {
    currentPage = search.page ? +search.page : 1
    pageSize = search.pageSize ? +search.pageSize : 10
    timeSort = ''
    getData()
    filter = {
      type: '',
      title: '',
      status: '',
      startTime: '',
      endTime: ''
    }
    api.getScheduleTypes().then(data => {
      setTyeList(data)
    })
  }, [])

  const getData = () => {
    setLoading(true)
    api.getScheduleList({ limit: pageSize, page: currentPage, sortMethod: timeSort, ...filter }).then(data => {
      setList(data.list)
      setCount(data.count)
      setLoading(false)
    }).catch(() => setLoading(false))
  }

  const onChangeTable = (pagination, filters, sorter) => {
    switch(sorter.order) {
      case 'ascend':
        timeSort = 'asc'
        break
      case 'descend':
        timeSort = 'desc'
        break
      default:
        timeSort = ''
    }
    currentPage = pagination.current
    pageSize = pagination.pageSize
    history.replace(`${match.path}?page=${currentPage}&pageSize=${pageSize}`)
    getData()
  }

  const formSubmit = (e) => {
    e.preventDefault()
    currentPage = 1
    history.replace(match.path)
    const vals = getFieldsValue()
    filter.type = vals.type
    filter.title = vals.title
    filter.status = vals.status
    if (vals.range) {
      filter.startTime = moment(vals.range[0]).format('YYYY-MM-DD')
      filter.endTime = moment(vals.range[1]).format('YYYY-MM-DD')
    }
    getData()
  }

  // 重置
  const onReset = () => {
    resetFields()
    filter = {
      type: '',
      title: '',
      status: '',
      startTime: '',
      endTime: ''
    }
    currentPage = 1
    history.replace(match.path)
    getData()
  }

  const onSetConfig = () => {
    setShowConfig(true)
    api.getScheduleConfig().then(data => {
      setConfigList(data)
      setSelectedkeys(data.filter(item => item.checked).map(item => item.id))
    })
  }

  const onSaveConfig = () => {
    api.setScheduleConfig({ config: selectedKeys }).then(() => {
      setShowConfig(false)
      message.success('设置成功')
      getData()
    })
  }

  const onSchedule = (title) => {
    Modal.info({
      title: '消息内容',
      content: (
        <div>
          <p>{title}</p>
        </div>
      ),
      onOk() {
      }
    })
  } 

  return (
    <>
      <div>
        <Form layout="inline" onSubmit={formSubmit}>
          <FormItem label="类型">
            {getFieldDecorator('type', { initialValue: '' })(
              <Select placeholder="请选择" style={{ width: 150 }}>
                <Option value={''}>全部</Option>
                {typeList.map(item => <Option key={item.id} value={item.id}>{item.name}</Option>)}
              </Select>
            )}
          </FormItem>
          <FormItem label="标题">
            {getFieldDecorator('title', { initialValue: '' })(<Input placeholder="请输入" />)}
          </FormItem>
          <FormItem label="状态">
            {getFieldDecorator('status', { initialValue: '' })(
              <Select placeholder="请选择" style={{ width: 150 }}>
                <Option value="">全部</Option>
                <Option value="0">未处理</Option>
                <Option value="1">已处理</Option>
              </Select>
            )}
          </FormItem>
          <FormItem label="创建时间">
            {getFieldDecorator('range', { initialValue: ''})(<RangePicker />)}
          </FormItem>
          <FormItem>
            <BtnGroup right style={{ marginTop: 4 }} cancelName="重置" confirmName="查询" onCancel={onReset} />
          </FormItem>
        </Form>
      </div>
      <div className="mark-wrap"><Button type="primary" onClick={onSetConfig}>设置</Button></div>
      <Alert className="alert-ant" message={`总计：${count}条数据`} type="info" showIcon />
      <Table
        dataSource={list}
        rowKey="id"
        className="table-ant"
        loading={loading}
        pagination={{
          pageSize,
          total: count,
          current: currentPage,
          showQuickJumper: true,
          showSizeChanger: true,
          pageSizeOptions: ['10', '50', '100', '500', '1000', '2000']
        }}
        scroll={{ x: 1000 }}
        onChange={onChangeTable}
      >
        <Column title="类型" dataIndex="typeName" />
        <Column title="内容"
          dataIndex="title"
          render={(text, record) => scheduleObj[record.type] ?
            <Link to={
              [53, 54, 55, 56, 60, 61, 62, 63, 64].includes(record.type)
                ? scheduleObj[record.type]
                : cryptoParamsIntoUrl(scheduleObj[record.type], { id: record.targetId })
            }>
              {record.type == 15 ? `[${record.applyUser.name}] ${text}` : text}
            </Link> :
            <div onClick={() => onSchedule(text)}>{record.type == 15 ? `[${record.applyUser.name}] ${text} ` : text}</div>
          }
        />
        <Column title="申请人" dataIndex="applyUser.name" />
        <Column title="创建时间" dataIndex="addTime" sorter={true} />
        <Column title="状态" dataIndex="statusName" />
      </Table>
      <Drawer
        title="待办事项设置"
        width={450}
        onClose={() => setShowConfig(false)}
        visible={showConfig}
      >
        <div className="config-wrap">
          <Alert message="请设置是否接收待办事项，勾选后，接收待办事项" type="info" showIcon />
          <Table 
            dataSource={configList} 
            rowKey="id"
            rowSelection={{
              fixed: true,
              selectedRowKeys: selectedKeys,
              onChange: data => setSelectedkeys(data)
            }}
            pagination={false}
          >
            <Column title="审批类型" dataIndex="name" />
          </Table>
          <BtnGroup style={{ marginTop: 20 }} onCancel={()=> setShowConfig(false)} onConfirm={onSaveConfig} />
        </div>  
      </Drawer>
    </>
  )
}

export default Form.create()(Schedule)